import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/shared/ui';

interface EmailTemplatesToolbarProps {
  /** Controlled search value. The parent owns debouncing and filtering. */
  search: string;
  onSearchChange: (value: string) => void;
  onCreateClick: () => void;
}

export function EmailTemplatesToolbar({
  search,
  onSearchChange,
  onCreateClick,
}: EmailTemplatesToolbarProps) {
  const { t } = useTranslation('knowledge');

  return (
    <div className="flex items-center justify-between gap-4 px-section py-4">
      <SearchInput
        className="w-80"
        value={search}
        onChange={onSearchChange}
        placeholder={t('knowledgeHub.emailTemplatesToolbar.searchTemplatesByName')}
        aria-label={t('knowledgeHub.emailTemplatesToolbar.searchEmailTemplates')}
      />
      <Button size="default" onClick={onCreateClick}>
        <PlusIcon className="size-4" />
        {t('knowledgeHub.emailTemplatesToolbar.newEmailTemplate')}
      </Button>
    </div>
  );
}
